/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
import React from 'react';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { actionForState } from '../../../utils/helpers';
import {
    FETCH_PORTAL_TRAININGS,
    FETCH_TRAINING_DETAIL,
    SAVE_CONTENT_INFO,
    FETCH_TRAINING_DRAFT,
    COMPLETE_PORTAL_TRAINING,
    CLEARSTATE,
    GET_SCORM_FILE_CONTENT,
    SAVE_SCORM_TRAINING_INFO,
    FATCH_SCORM_TRAINING_INFO,
    DOWNLOAD_TRAINING_CERTIFICATE
} from './types';

const INITIAL_STATE = {
    trainingCompletion: {
        success: false,
        loading: false,
        error: false
    },
    actionPortalTrainingsFetch: {
        success: false,
        loading: false,
        message: ''
    },
    trainingFetchAction: {
        success: false,
        loading: false,
        error: false,
        message: ''
    },
    saveContentAction: {
        success: false,
        loading: false,
        error: false
    },
    trainingDraftAction: {
        success: false,
        loading: false,
        message: ''
    },
    completeTrainingAction: {
        success: false,
        loading: false,
        message: ''
    },
    getScormContentAction: {
        success: false,
        loading: false,
        error: false
    },
    saveScormContentAction: {
        success: false,
        loading: false,
        error: false
    },
    fetchScormContetAction: {
        success: false,
        loading: false,
        error: false
    },
    downloadCertificatetAction: {
        success: false,
        loading: false,
        error: false,
        message: ''
    },
    errorMess: false
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_PORTAL_TRAININGS.pending:
            return {
                ...state,
                actionPortalTrainingsFetch: actionForState(state.action, 'pending')
            };
        case FETCH_PORTAL_TRAININGS.success:
            return {
                ...state,
                myTrainings: action.payload,
                actionPortalTrainingsFetch: actionForState(state.action, 'success')
            };
        case FETCH_PORTAL_TRAININGS.error:
            return {
                ...state,
                actionPortalTrainingsFetch: actionForState(state.action, 'error')
            };
        case FETCH_TRAINING_DETAIL.pending:
            return {
                ...state,
                trainingFetchAction: actionForState(state.action, 'pending'),
                errorMess: false
            };
        case FETCH_TRAINING_DETAIL.success:
            return {
                ...state,
                trainingDetail: action.payload,
                trainingFetchAction: actionForState(state.action, 'success'),
                errorMess: false
            };
        case FETCH_TRAINING_DETAIL.error:
            return {
                ...state,
                trainingFetchAction: actionForState(state.action, 'error'),
                errorMess: true
            };
        case SAVE_CONTENT_INFO.pending:
            return {
                ...state,
                saveContentAction: actionForState(state.action, 'pending')
            };
        case SAVE_CONTENT_INFO.success:
            return {
                ...state,
                trainingDraft: action.payload,
                saveContentAction: actionForState(state.action, 'success')
            };
        case SAVE_CONTENT_INFO.error:
            return {
                ...state,
                saveContentAction: actionForState(state.action, 'error')
            };
        case FETCH_TRAINING_DRAFT.pending:
            return {
                ...state,
                trainingDraftAction: actionForState(state.action, 'pending')
            };
        case FETCH_TRAINING_DRAFT.success:
            return {
                ...state,
                trainingDraft: action.payload,
                trainingDraftAction: actionForState(state.action, 'success')
            };
        case FETCH_TRAINING_DRAFT.error:
            return {
                ...state,
                trainingDraftAction: actionForState(state.action, 'error')
            };
        case COMPLETE_PORTAL_TRAINING.pending:
            state.toastId = toast(
                <FormattedMessage
                    id="reducer.toast.bar.portal.training.progress"
                    defaultMessage="Training completion in Progress"
                />,
                { type: toast.TYPE.INFO }
            );
            return {
                ...state,
                trainingCompletion: {
                    success: false,
                    loading: true,
                    error: false
                },
                completeTrainingAction: actionForState(state.action, 'pending')
            };
        case COMPLETE_PORTAL_TRAINING.success:
            toast.update(state.toastId, {
                render: (
                    <FormattedMessage
                        id="reducer.toast.bar.portal.complete.training"
                        defaultMessage="Training has completed successfully."
                    />
                ),
                type: toast.TYPE.SUCCESS,
                className: 'rotateY animated'
            });
            state.toastId = null;
            return {
                ...state,
                trainingCompletion: {
                    success: true,
                    loading: false,
                    error: false
                },
                completeTrainingAction: actionForState(state.action, 'success')
            };
        case COMPLETE_PORTAL_TRAINING.error:
            toast.update(state.toastId, {
                render: (
                    <FormattedMessage
                        id="reducer.toast.bar.portal.training.error"
                        defaultMessage="Error occured while training completion."
                    />
                ),
                type: toast.TYPE.ERROR,
                className: 'rotateY animated'
            });
            state.toastId = null;
            return {
                ...state,
                trainingCompletion: {
                    success: false,
                    loading: false,
                    error: true
                },
                completeTrainingAction: actionForState(state.action, 'error')
            };
        case DOWNLOAD_TRAINING_CERTIFICATE.pending:
            return {
                ...state,
                downloadCertificatetAction: actionForState(state.action, 'pending')
            };
        case DOWNLOAD_TRAINING_CERTIFICATE.success:
            return {
                ...state,
                trainingCertificate: action.payload,
                downloadCertificatetAction: actionForState(state.action, 'success')
            };
        case DOWNLOAD_TRAINING_CERTIFICATE.error:
            return {
                ...state,
                downloadCertificatetAction: actionForState(state.action, 'error')
            };
        case CLEARSTATE:
            return {
                ...state,
                trainingCompletion: {
                    success: false,
                    loading: false,
                    error: false
                },
                trainingFetchAction: {
                    success: false,
                    loading: false,
                    error: false,
                    message: ''
                },
                getScormContentAction: {
                    success: false,
                    loading: false,
                    error: false
                },
                saveScormContentAction: {
                    success: false,
                    loading: false,
                    error: false
                },
                fetchScormContetAction: {
                    success: false,
                    loading: false,
                    error: false
                },
                errorMess: false
            };
        case GET_SCORM_FILE_CONTENT.pending:
            return {
                ...state,
                getScormContentAction: actionForState(state.action, 'pending')
            };
        case GET_SCORM_FILE_CONTENT.success:
            return {
                ...state,
                scormURL: action.payload,
                getScormContentAction: actionForState(state.action, 'success')
            };
        case GET_SCORM_FILE_CONTENT.error:
            return {
                ...state,
                getScormContentAction: actionForState(state.action, 'error')
            };
        case SAVE_SCORM_TRAINING_INFO.pending:
            return {
                ...state,
                saveScormContentAction: actionForState(state.action, 'pending')
            };
        case SAVE_SCORM_TRAINING_INFO.success:
            return {
                ...state,
                scormTrainingDraft: action.payload,
                saveScormContentAction: actionForState(state.action, 'success')
            };
        case SAVE_SCORM_TRAINING_INFO.error:
            return {
                ...state,
                saveScormContentAction: actionForState(state.action, 'error')
            };
        case FATCH_SCORM_TRAINING_INFO.pending:
            return {
                ...state,
                fetchScormContetAction: actionForState(state.action, 'pending')
            };
        case FATCH_SCORM_TRAINING_INFO.success:
            return {
                ...state,
                scormTrainingDraft: action.payload,
                fetchScormContetAction: actionForState(state.action, 'success')
            };
        case FATCH_SCORM_TRAINING_INFO.error:
            return {
                ...state,
                fetchScormContetAction: actionForState(state.action, 'error')
            };
        default:
            return state;
    }
}
